import {
  PermissionMap,
  PlatformDomainObjectType,
  PlatformPermission,
} from "@chemaxon/terminus-client/ui/models/Permission";

export enum PlatformRole {
  ROLE_TEAM_ADMIN = "ROLE_TEAM_ADMIN",
  ROLE_SCIM_TEAM_ADMIN = "ROLE_SCIM_TEAM_ADMIN",
  ROLE_USER = "ROLE_USER",
  ROLE_CRO = "ROLE_CRO",
  ROLE_EXTERNAL = "ROLE_EXTERNAL",
  ROLE_PROJECT_CREATOR = "ROLE_PROJECT_CREATOR",
}

export const createCheckPermission =
  (permissions: PermissionMap) =>
  (
    platformDomainObjectType: PlatformDomainObjectType,
    platformPermission: PlatformPermission,
  ) => {
    const resolvedPermission = permissions[platformDomainObjectType];

    if (resolvedPermission) {
      return (
        resolvedPermission.includes(platformPermission) ||
        resolvedPermission.includes(PlatformPermission.ALL)
      );
    }

    return false;
  };

export const hasTeamAdminRole = (authorities: string[]) =>
  authorities.filter(
    ca =>
      ca.toString() === PlatformRole.ROLE_TEAM_ADMIN ||
      ca.toString() === PlatformRole.ROLE_SCIM_TEAM_ADMIN,
  ).length > 0;
